"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var GSIconSecurity = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M12 5.647c-1.108 0-2.043.9-2.043 1.965v.83h-.215c-.5 0-.906.406-.906.905v3.591c0 .5.406.905.906.905h4.516c.5 0 .906-.406.906-.905V9.347c0-.5-.406-.905-.905-.905h-.216v-.83c0-1.065-.936-1.965-2.043-1.965Zm-.36 1.965c0-.111.155-.282.36-.282s.36.17.36.282v.83h-.72v-.83Zm1.84 4.548h-2.96v-2.036h2.96v2.036Z", fill: "currentColor" }), (0, jsx_runtime_1.jsx)("path", { d: "M19.58 3.168V2.39c0-.5-.405-.905-.904-.905H5.325c-.5 0-.906.406-.906.905v12.558c0 .24.098.476.266.64l6.675 6.664a.902.902 0 0 0 1.278 0l6.674-6.661a.912.912 0 0 0 .268-.643V4.452l-1.683 1.635v8.539L12 20.512l-5.898-5.886V3.168h13.478Z", fill: "currentColor" })] }))); };
exports.default = GSIconSecurity;
